import { useContext, useEffect } from "react";

import { Sidebar } from "@shapr3d/frontend-lib";
import { useMatch, useParams } from "react-router-dom";

import useNavigation from "../../../../hooks/navigation";
import { useTracker } from "../../../../hooks/useTracker";
import { NavBarContext } from "../../TeamsLayout";
import { NavGroupContext } from "../NavGroup/NavGroup";

export const NavItem = ({
  name,
  ...props
}: {
  name: string;
  track?: (args: { activeTeamId: string; location: "account_sidebar" }) => void;
  onClick?: () => void;
  children: React.ReactNode;
}) => {
  const tracker = useTracker();
  const navigation = useNavigation();
  const { teamID } = useParams();

  const { onSelect } = useContext(NavBarContext);
  const { setIsActiveMap } = useContext(NavGroupContext);

  const match = useMatch(`/teams/:id/${name}`);
  useEffect(() => {
    setIsActiveMap((old) => ({ ...old, [name]: Boolean(match) }));
  }, [match, name, setIsActiveMap]);

  if (!teamID) return null;

  return (
    <Sidebar.NavItem
      selected={Boolean(match)}
      {...props}
      onClick={() => {
        onSelect();
        navigation.goToTeamPage({ teamID, page: name });
        props.track?.bind(tracker, {
          activeTeamId: teamID,
          location: "account_sidebar",
        })();
        props.onClick?.();
      }}
    >
      {props.children}
    </Sidebar.NavItem>
  );
};
